import React from 'react';
import PropTypes from 'prop-types';
import { NavMenuPrimitives } from '@uhg-abyss/web/ui/NavMenu';
import { NavMenuLinkNew } from './NavMenuLinkNew';

export const DropDownContentNew = ({ contents }) => {
  return (
    <NavMenuPrimitives.Columns>
      <NavMenuPrimitives.Column>
        <For each="content" of={contents}>
          <If condition={content.type === 'link'}>
            <NavMenuLinkNew {...content} />
          </If>
        </For>
      </NavMenuPrimitives.Column>
    </NavMenuPrimitives.Columns>
  );
};

DropDownContentNew.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      description: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
};
